module.exports = __webpack_public_path__ + "img/wifi.29094a9e.svg";